import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logout from "./pages/Logout";
import logo from '../Assets/logo/skilletix.png'
import { useAuth } from "../AuthContext";

const Header = () => {
  const { isAuthenticated, logout } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const userType = localStorage.getItem("userType");
  const userid = localStorage.getItem("userid");
  const [isNavbarOpen, setIsNavbarOpen] = useState(false); 
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  const logout_user = () => {
    setIsModalOpen(true);
  };

  const confirmLogout = () => {
    setIsModalOpen(false);
    logout();
    localStorage.clear();
    navigate("/login");
  };

  const cancelLogout = () => {
    setIsModalOpen(false);
  }

  const toggleNavbar = () => {
    setIsNavbarOpen((prevState) => !prevState);
  };

  const handleNavLinkClick = () => {
    setIsNavbarOpen(false);
  };
  useEffect(() => {
    const handleScroll = () => {
      setIsNavbarOpen(false); 
    };
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize); 
  }, []);

  return (
    <div className="main-navigation">
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <Link to={'/'} className="navbar-brand" href="">
            <img
            loading="lazy"
            role="presentation"
            decoding="async"
            fetchpriority="high" src={logo} alt="Logo" />
          </Link>
          <div className="mobile-menu-right">
            <button
              className="navbar-toggler"
              type="button"
              aria-expanded={isNavbarOpen}
              aria-label="Toggle navigation"
              onClick={toggleNavbar} 
            >
              <span className="navbar-toggler-btn-icon">
                <i className="far fa-bars" />
              </span>
            </button>
          </div>
          <div
            className={`collapse navbar-collapse ${isNavbarOpen ? "show" : ""}`}
            id="main_nav"
          >
            <ul className="navbar-nav">
              <li className="nav-item dropdown">
                <Link to={"/"} className="nav-link dropdown-toggle1" onClick={handleNavLinkClick}>
                  Home
                </Link>
              </li>
              {userType === "candidate" && (
                <li className="nav-item dropdown">
                  <Link
                    to={"/candidatedashboard"}
                    className="nav-link dropdown-toggle1"
                    onClick={handleNavLinkClick}
                  >
                    Dashboard
                  </Link>
                </li>
              )}
              {userType === "employer" && (
                <li className="nav-item dropdown">
                  <Link
                    to={"/employerdashboard"}
                    className="nav-link dropdown-toggle1"
                    onClick={handleNavLinkClick}
                  >
                    Dashboard
                  </Link>
                </li>
              )}
              {/* <li className="nav-item dropdown">
                <Link to={"/jobs"} className="nav-link dropdown-toggle1" onClick={handleNavLinkClick}>
                  Jobs
                </Link>
              </li> */}

              {userType !== "employer" && (
                <li className="nav-item dropdown">
                  <Link
                    to={"/jobs"}
                    className="nav-link dropdown-toggle1"
                    onClick={handleNavLinkClick}
                  >
                    Jobs
                  </Link>
                </li>
              )}

              {/* <li className="nav-item dropdown">
                <Link to={"/companies"} className="nav-link dropdown-toggle1" onClick={handleNavLinkClick}>
                  Companies
                </Link>
              </li> */}

              {userType !== "employer" && (
                <li className="nav-item dropdown">
                  <Link
                    to={"/companies"}
                    className="nav-link dropdown-toggle1"
                    onClick={handleNavLinkClick}
                  >
                    Companies
                  </Link>
                </li>
              )}
              
              {userType === "employer" && (
                <li className="nav-item dropdown">
                  <Link
                    to={"/manage-candidates"}
                    className="nav-link dropdown-toggle1"
                    onClick={handleNavLinkClick}
                  >
                    Manage candidates 
                  </Link>
                </li>
              )}
              {/* {userType === "candidate" && (
                <li className="nav-item dropdown">
                  <Link
                    to={"/saved-jobs"}
                    className="nav-link dropdown-toggle1"
                    onClick={handleNavLinkClick}
                  >
                    Saved Jobs
                  </Link>
                </li>
              )} */}
              <li className="nav-item dropdown">
                <Link to={"/contact-us"} className="nav-link dropdown-toggle1" onClick={handleNavLinkClick}>
                  Contact Us
                </Link>
              </li>
              {isMobile && userid ? (
    <li className="nav-item dropdown">
      <button className="nav-link dropdown-toggle1" onClick={logout_user}>
        Log Out
      </button>
    </li>
  ) : isMobile && !userid ? (
    <li className="nav-item dropdown">
      <Link to={"/login"} className="nav-link dropdown-toggle1" onClick={handleNavLinkClick}>
        Sign In
      </Link>
    </li>
  ) : null}
            </ul>
            
            <div className="header-nav-right">
              <div className="header-btn">
                {(userType === "candidate" || !userType) && (
                  <Link
                    to={userid ? "/jobs" : "/login"}
                    state={{ searchJob: true }}
                    className="theme-btn"
                    onClick={handleNavLinkClick}
                  >
                    <span className="fa-solid fa-person-ski-jumping" /> Get A Job
                  </Link>
                )}
                {(userType === "employer" || !userType) && (
                  <Link
                    to={userid ? "/postjob" : "/login"}
                    className="theme-btn"
                    onClick={handleNavLinkClick}
                  >
                    <span className="far fa-suitcase" /> Post A Job
                  </Link>
                )}
                {!isMobile && userid ?  (
                  <button className="theme-btn" onClick={logout_user}>
                    <span className="fa-solid fa-right-from-bracket" /> Log Out
                  </button>
                ) : !userid ?(
                  <Link to={"/login"} className="theme-btn theme-btn2" onClick={handleNavLinkClick}>
                    <span className="far fa-sign-in" /> Sign In
                  </Link>
                ): null}
              </div>
            </div>
          </div>
        </div>
      </nav>
      <Logout
        isOpen={isModalOpen}
        onConfirm={confirmLogout}
        onCancel={cancelLogout}
      />
    </div>
  );
};
export default Header;
